import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  author: string;
  version: number;
  lap: number;
  topic: string;
  keywords: string[];
  flowType: string;
}
const DetailsCell = (props: Props) => {
  const { author, version, topic, keywords, flowType, lap } = props;
  const { t } = useTranslation();
  const hasKeywords = keywords.length > 0;

  const renderKeywords = () => keywords.map((x, i) => <li key={`keyword_${i.toString()}`}>{x}</li>);

  return (
    <div className="flow-comments-details">
      <span>{author}</span>
      <strong>
        {t('forFlowVersion', { flowType, version: version.toString(), lap: lap.toString() })}
      </strong>
      <p>
        <span>Topic: </span>
        {topic}
      </p>
      {hasKeywords && (
        <>
          <p>
            <span>Keywords:</span>
          </p>
          <ul>{renderKeywords()}</ul>
        </>
      )}
    </div>
  );
};

export default DetailsCell;
